module.exports = __webpack_public_path__ + "img/19.8.C.f3d7a544.png";